// Services
import breedingManagementService from "@/app/services/main/breeder/breeding-management-service.js"

// Heat Cycle Info
import HEAT_CYCLE_INFO from "@/app/views/main-view/breeders/components/breeder-gestation-period/constants/heat-cycle.info.js";

// Mixins
import { dateMixins } from "@/app/mixins/utils/date-mixins";
import { toastMessageMixins } from "@/app/mixins/utils/toast-message-mixins";
// import { unsavedChangesModalMixins } from "@/app/mixins/utils/unsaved-changes-mixins.js";

// Third Party libraries
import DatePicker from "vue2-datepicker";

// Constants
import { STATUS_CODES, SUCCESS_MSG } from '@/app/constants/constants.js';

export default {
    name: "GestationPeriodContainer",
    components: {
        DatePicker,
    },
    mixins: [dateMixins, toastMessageMixins],
    data() {
        return {
            isAPILoading: false,
            isAPISubmitLoading: false,
            HEAT_CYCLE_INFO,

            damId: null,
            breederSysId: null,
            damDetails: null,

            firstDayOfCycle: null,
            ovulationCycleRange: [],

            matingDate: null,
            whelpingDatesRange: [],
            whelpingDatesRangeLegend: null,

            previousWhelpingDates: [],
            diaryDetails: [],

            initialValues: {
                firstDayOfCycle: null,
                matingDate: null,
            },

            prevRoute: 'Dam Details',
        };
    },
    computed: {
        dogImageSource(){
            return this.damDetails && this.damDetails.imageUrl ? this.damDetails.imageUrl : require('@/assets/images/_shared/dog-purchase.png');
        }
    },
    async created() {
        this.damId = this.$route.params.id;
        this.breederSysId = this.$route.params.breederSysId;
        
        if (this.$route.params) {
            await this.getDamOvulationAndGestationDetails(this.$route.params.id, this.$route.params.breederSysId);
            await this.getDiaryDetails(this.$route.params.id, this.$route.params.breederSysId);

            if(this.$route.query.from === "mating-details"){
                this.prevRoute = "Mating Details";
            } 
        }

    },
    methods: {
        async onSubmitDetails() {
            try {
                this.isAPISubmitLoading = true;

                if (!this.firstDayOfCycle && !this.matingDate) {
                    await this.$swal({
                        text: "Please provide either the first day of the cycle or the mating date.",
                        imageHeight: "30px",
                        imageUrl: `${require("@/assets/images/_shared/sad-dog.png")}`,
                        imageAlt: "Sad Dog",
                        confirmButtonText: "Got it",
                        showCloseButton: true,
                    });

                    return;
                }

                const { SUCCESS_ADD_OVULATION_GESTATION, ERROR_ADD_OVULATION_GESTATION } = this.toastMessages.ovulationGestation();

                // format dates to properly save them (not index 0)
                const detailsToSave = {
                    damId: this.damId,
                    breederSysId: this.breederSysId,
                    ovulationStartDate: this.firstDayOfCycle ? this.formatDateWithoutConversion(this.firstDayOfCycle, "yyyy-MM-dd") : null,
                    matingDate: this.matingDate ? this.formatDateWithoutConversion(this.matingDate, "yyyy-MM-dd") : null,
                };

                const response = await breedingManagementService.saveOvulationAndGestation(detailsToSave);

                if (response.status === STATUS_CODES.SUCCESS_POST) {
                    this.showCustomSuccessToast(SUCCESS_MSG.SUCCESS_TITLE, SUCCESS_ADD_OVULATION_GESTATION);
                    this.isAddingSuccess = true;

                    await this.getDamOvulationAndGestationDetails(this.damId, this.breederSysId);
                } else {
                    this.showAPIErrorToast(ERROR_ADD_OVULATION_GESTATION, response);
                }

            } catch (err) {
                console.log(err)
                this.showGenericErrorToast();
            } finally {
                this.isAPISubmitLoading = false;
            }
        },
        async getDamOvulationAndGestationDetails(damId, breederSysId){
            try{
                this.isAPILoading = true;

                const detailsResponse = await breedingManagementService.getDamOvulationAndGestationDetails(damId, breederSysId);
          
                if (detailsResponse.status === STATUS_CODES.SUCCESS) {
                    this.damDetails = detailsResponse.data;

                    const { ovulationDetails, gestationDetails, previousWhelpingDates} = detailsResponse.data;

                    if(ovulationDetails){
                        const { startDate: firstDayOfCycle, endDate: lastDayOfCycle } = ovulationDetails;

                        this.firstDayOfCycle = firstDayOfCycle ? new Date(firstDayOfCycle) : null;
                        this.initialValues.firstDayOfCycle = this.firstDayOfCycle;

                        if(firstDayOfCycle && lastDayOfCycle){
                            this.ovulationCycleRange = [ new Date(firstDayOfCycle), new Date(lastDayOfCycle)];
                        }
                    }

                    if(gestationDetails){
                        const { matingDate, whelpingPeriodStart, whelpingPeriodEnd } = gestationDetails;

                        this.matingDate = matingDate ? new Date(matingDate) : null;
                        this.initialValues.matingDate = this.matingDate;

                        if(whelpingPeriodStart && whelpingPeriodEnd){
                            this.whelpingDatesRange = [new Date(whelpingPeriodStart), new Date(whelpingPeriodEnd)];
                            this.whelpingDatesRangeLegend = Array.isArray(this.whelpingDatesRange) && this.whelpingDatesRange.length === 2 ?  [...this.whelpingDatesRange].map(date => this.formatDateWithoutConversion(date)).join(" ~ ") : "N/A";
                        }
    
                        this.formatOvulationCycleCalendar("ovulation-cycle-calendar");
                        this.formatOvulationCycleCalendar("wheling-dates-calendar");
                    }

                    if(previousWhelpingDates){
                        this.previousWhelpingDates = previousWhelpingDates.map((data) => {
                            return { ...data, date: new Date(data.whelpingDate) };
                        });
                    }

                    this.$nextTick(() => {
                        this.formatOvulationCycleCalendar("ovulation-cycle-calendar");
                        this.formatOvulationCycleCalendar("wheling-dates-calendar");
                    });

                } else {
                    const { ERROR_GET_DAM_SIRE } = this.toastMessages.damSire();
                    this.showAPIErrorToast(ERROR_GET_DAM_SIRE, detailsResponse);
                }
                
            } catch(err){
                this.showGenericErrorToast();
            }  finally {
                this.isAPILoading = false;
            }
        },
        async getDiaryDetails(damId, breederSysId) {
            // const { ERROR_FETCHING_PREVIOUS_OVULATION } = this.toastMessages.ovulationGestation();

            try {
                const response = await breedingManagementService.getDamDiaryDetails(damId, breederSysId);
                if (response.status === STATUS_CODES.SUCCESS) {
                    this.diaryDetails = [...response.data];
                } else {
                    this.showGenericErrorToast();
                }
            } catch (err) {
                this.showGenericErrorToast();
            }
        },
        onChangeFirstDayOfCycle() {
            if (!this.firstDayOfCycle) return;

            const endDate = new Date(this.firstDayOfCycle);

            // Add 20 days
            endDate.setDate(endDate.getDate() + 20);

            this.ovulationCycleRange = [
                new Date(this.firstDayOfCycle),
                new Date(endDate),
            ];

            // this will ensure the DOM is ready before manually adding some updates
            this.$nextTick(() => {
                this.formatOvulationCycleCalendar("ovulation-cycle-calendar");
            });
        },
        onChangeMatingDate() {
            if (!this.matingDate) return;

            const startDate = new Date(this.matingDate);
            const endDate = new Date(this.matingDate);

            startDate.setDate(startDate.getDate() + 60);
            endDate.setDate(endDate.getDate() + 65);

            this.whelpingDatesRange = [startDate, endDate];

            this.whelpingDatesRangeLegend = Array.isArray(this.whelpingDatesRange) && this.whelpingDatesRange.length === 2 ?  [...this.whelpingDatesRange].map(date => this.formatDateWithoutConversion(date)).join(" ~ ") : "N/A";
            
            // this will ensure the DOM is ready before manually adding some updates
            this.$nextTick(() => {
                this.formatOvulationCycleCalendar("wheling-dates-calendar");
            });
        },
        formatOvulationCycleCalendar(wrapperClass) {
            const dataTableWrapper = document.querySelector(`.${wrapperClass}`);

            if (dataTableWrapper) {
                const cells = dataTableWrapper.querySelectorAll(".cell");

                if (cells && cells.length) {
                    [...cells].forEach((cell) => {
                        cell.classList.add("reset-highlight");
                        cell.classList.remove("highlight-active");
                    });
                }

                const cellsInRangeOrActive = dataTableWrapper.querySelectorAll(".cell.in-range, .cell.active");

                if (cellsInRangeOrActive && cellsInRangeOrActive.length) {

                    // exclude the cells which have the class below to not affect their styling
                    const toModifyRange = [...cellsInRangeOrActive].filter((cell) => {
                            return !cell.classList.contains("not-current-month");
                        }
                    );

                    // this makes sure that only get the first to 21st element
                    const slicedArray = [...toModifyRange].slice(0, 21);

                    // only select the last four elements
                    [...slicedArray].slice(-4).forEach((cell) => {
                        cell.classList.add("highlight-active");
                    });

                    [...cellsInRangeOrActive].forEach((cell) => {
                        cell.classList.remove("reset-highlight");

                        if (cell.classList.contains("not-current-month")) {

                            // manually reset the styling of them, overriding its default behavior
                            cell.classList.add("reset-highlight");
                        }
                    });
                }

                // these are the calendar popups
                const dateTables = dataTableWrapper.querySelectorAll(".mx-calendar.mx-calendar-panel-date");
                if (dateTables && dateTables.length) {
                    [...dateTables].forEach((table) => {
                        // Select cells with either .in-range or .active class within the current table, exclude cells with class not(.not-current-month)
                        const cellsInTableRangeOrActive = table.querySelectorAll(".cell.in-range:not(.not-current-month), .cell.active:not(.not-current-month)");

                        // hide the table if they don't have an active cell or it's not in range
                        if (!cellsInTableRangeOrActive.length) {
                            table.classList.add("hide-table");
                        } else {
                            table.classList.remove("hide-table");
                        }
                    });
                }
            }
        },
        notFutureOfMatingDate(date) {
            if (!this.matingDate) {
                return false; 
            }

            // disable dates after the mating date
            return date > new Date(this.matingDate);
        },
        notPastFirstDayOfCycle(date) {
            if (!this.firstDayOfCycle) {
                return false; 
            }

            // disable dates before the first day of the cycle
            return date < new Date(this.firstDayOfCycle);
        },
        diaryTimelineItems() {
            let items = [];
            const dateFormat = "MMMM dd, yyyy";
            for (const data of this.diaryDetails) {
                let content = "";
                content += `<p class="mb-0"><span style="font-weight: 700 !important;">1st day of cycle:</span> ${
                    data.ovulationCycleDate ? this.formatDateTime(data.ovulationCycleDate, dateFormat) : "N/A"
                }</p>`;
                content += `<p class="mb-0"><span style="font-weight: 700 !important;">Mating date:</span> ${
                    data.gestationTrackerDate ? this.formatDateTime(data.gestationTrackerDate, dateFormat) : "N/A"
                }</p>`;
               
                content += `<p class="mb-0"><span style="font-weight: 700 !important;">Whelping date:</span> ${data.whelpingDate ? this.formatDateTime(data.whelpingDate, dateFormat) : "N/A"}</p>`;
                content += `<p class="mb-0"><span style="font-weight: 700 !important;">Type of Birth:</span> ${data.typeOfBirth ? data.typeOfBirth : "N/A"}</p>`;

                items.push({
                    htmlMode: true,
                    content: content,
                });
            }
            return items;
        },

    },
    // async beforeRouteLeave(to, from, next) {
    //     const isFirstDayOfCycleChanged = (this.initialValues.firstDayOfCycle ? this.initialValues.firstDayOfCycle.getTime() : null) !== (this.firstDayOfCycle ? this.firstDayOfCycle.getTime() : null);
    //     const isMatingDateChanged = (this.initialValues.matingDate ? this.initialValues.matingDate.getTime() : null) !== (this.matingDate ? this.matingDate.getTime() : null);

    //     const isDataChanged = isFirstDayOfCycleChanged || isMatingDateChanged;

    //     if(isDataChanged){
    //         const result = await this.showUnsavedChangesModal();

    //         if (result.value) {
    //             next(true);
    //         } else {
    //             next(false);
    //         }

    //     } else {
    //         next(true);
    //     }
    // },
};
